import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { IconColor } from '@freelancer/ui/icon';
import {
  SpinnerBackgroundColor,
  SpinnerColor,
  SpinnerSize,
  SpinnerType,
} from './spinner.types';

@Component({
  selector: 'fl-spinner',
  template: `
    <fl-bit
      class="Spinner"
      role="presentation"
      [attr.data-color]="overlay ? SpinnerColor.PRIMARY : color"
      [attr.data-size]="size"
      [attr.data-type]="type"
    >
      <fl-icon
        *ngIf="type === SpinnerType.HOURGLASS"
        class="SpinnerIcon"
        [name]="'ui-hourglass'"
        [color]="IconColor.LIGHT"
      ></fl-icon>
      <fl-picture *ngIf="type === SpinnerType.BIRD" [src]="birdSrc">
      </fl-picture>
    </fl-bit>
  `,
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent implements OnInit {
  SpinnerColor = SpinnerColor;
  IconColor = IconColor;
  SpinnerType = SpinnerType;

  @Input() size: SpinnerSize = SpinnerSize.MID;
  @Input() color: SpinnerColor = SpinnerColor.PRIMARY;
  @Input() type: SpinnerType = SpinnerType.DEFAULT;

  @HostBinding('attr.data-background')
  @Input()
  backgroundColor: SpinnerBackgroundColor = SpinnerBackgroundColor.LIGHT;

  @HostBinding('class.Overlay')
  @Input()
  overlay = false;

  @HostBinding('class.IsModalOverlay')
  @Input()
  overlayForModal = false;

  birdSrc = 'bits/gif/bird-128-v3.gif';

  ngOnInit() {
    if (
      this.type === SpinnerType.BIRD &&
      (this.size === SpinnerSize.MID || this.size === SpinnerSize.LARGE)
    ) {
      this.birdSrc = 'bits/gif/bird-128-v3.gif';
    }

    if (this.type === SpinnerType.BIRD && this.size === SpinnerSize.SMALL) {
      this.birdSrc = 'bits/gif/bird-40.gif';
    }
  }
}
